import { hasImageInput, extractImageFrames, clampTo } from '../../tools';
import type { volcengineModelConfig } from '../types';

export const seedance1Configs: Record<string, volcengineModelConfig> = {
    'seedance-1.5-pro': {
        apiKeyEnv: 'VOLCENGINE_API_KEY_BEIJING',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, aspectRatio, duration, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'ep-20260530155303-tcjb4',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        {
                            type: "image_url",
                            image_url: { url: firstImage },
                            role: "first_frame"
                        },
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12] as const, 5),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : false,
                    draft: typeof providerOptions?.draft === 'boolean' ? providerOptions.draft : false,
                    camera_fixed: typeof modelUi?.cameraFixed === 'boolean' ? modelUi.cameraFixed : false,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    service_tier: 'default',
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                return {
                    model: 'ep-20260530155303-tcjb4',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        {
                            type: "image_url",
                            image_url: { url: firstImage },
                            role: "first_frame"
                        },
                        {
                            type: "image_url",
                            image_url: { url: lastImage || firstImage },
                            role: "last_frame"
                        },
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12] as const, 5),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : false,
                    draft: typeof providerOptions?.draft === 'boolean' ? providerOptions.draft : false,
                    camera_fixed: typeof modelUi?.cameraFixed === 'boolean' ? modelUi.cameraFixed : false,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    service_tier: 'default',
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                };
            // 文生视频模式
            } else {
                return {
                    model: 'ep-20260530155303-tcjb4',
                    content: [
                        {
                            type: "text",
                            text: prompt,
                        }
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12] as const, 5),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : false,
                    draft: typeof providerOptions?.draft === 'boolean' ? providerOptions.draft : false,
                    camera_fixed: typeof modelUi?.cameraFixed === 'boolean' ? modelUi.cameraFixed : false,
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    service_tier: 'default',
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                };
            }
        },
    },
    'seedance-1.0-pro': {
        apiKeyEnv: 'VOLCENGINE_API_KEY_BEIJING',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, aspectRatio, duration, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'ep-20260530155351-w2q4l',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        {
                            type: "image_url",
                            image_url: { url: firstImage },
                            role: "first_frame"
                        },
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const, 5),
                    frames: undefined,
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                    prioritynew: undefined,
                };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                return {
                    model: 'ep-20260530155351-w2q4l',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        {
                            type: "image_url",
                            image_url: { url: firstImage },
                            role: "first_frame"
                        },
                        {
                            type: "image_url",
                            image_url: { url: lastImage || firstImage },
                            role: "last_frame"
                        },
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const, 5),
                    frames: undefined,
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                    prioritynew: undefined,
                };
            // 文生视频模式
            } else {
                return {
                    model: 'ep-20260530155351-w2q4l',
                    content: [
                        {
                            type: "text",
                            text: prompt,
                        }
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const, 5),
                    frames: undefined,
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                    prioritynew: undefined,
                };
            }
        },
    },
    'seedance-1.0-pro-fast': {
        apiKeyEnv: 'VOLCENGINE_API_KEY_BEIJING',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, aspectRatio, duration, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'ep-20260530155435-5cq87',
                    content: [
                        {
                            type: "text",
                            text: prompt
                        },
                        {
                            type: "image_url",
                            image_url: { url: firstImage },
                            role: "first_frame"
                        },
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const, 5),
                    frames: undefined,
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                    prioritynew: undefined,
                };
            // 文生视频模式
            } else {
                return {
                    model: 'ep-20260530155435-5cq87',
                    content: [
                        {
                            type: "text",
                            text: prompt,
                        }
                    ],
                    resolution: clampTo(quality || '480p', ['480p', '720p', '1080p'] as const, '480p'),
                    ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['9:16', '3:4', '1:1', '4:3', '16:9', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const, 5),
                    frames: undefined,
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                    ...(typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search === true ? { tools: [{ "type": "web_search" }] } : { tools: undefined } : { tools: undefined }),
                    // system
                    callback_url: undefined,
                    return_last_frame: undefined,
                    execution_expires_after: undefined,
                    safety_identifiernew: undefined,
                    prioritynew: undefined,
                };
            }
        },
    },
}